import gql from "graphql-tag";

export default gql`
  mutation createHumidityMeasurementList($paramsList: [HumidityMeasurementParams]!) {
    createHumidityMeasurementList(paramsList: $paramsList)
  }
`;
